module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-38.4aab5719.png";